import type { PrescriptionPadStep } from '@/components/Patient/components/PrescriptionPad/PrescriptionPad.types';
import { getFormulationDispenseLimitRows } from '@/utils/dosageLimit/getFormulationDispenseLimitRows';
import type { StateCreator } from 'zustand';
import type { PrescriptionAssistantSliceType } from '../types';
import { setRevalidatedPad } from '../utils/setRevalidatedPad';
import { syncDosageSuffixToStep } from '../utils/syncDosageSuffixToStep';

export const updatePrescriptionPadStep: StateCreator<
  PrescriptionAssistantSliceType,
  [['zustand/immer', never], ['zustand/devtools', never]],
  [],
  (step: PrescriptionPadStep) => void
> = (set, get) => (step) => {
  const { prescriptionPad, prescriptionPadRules } = get().prescriptionAssistant;
  // A step changes no quantity, interval or limit, so these rows also stand after it
  const dispenseLimitRows = getFormulationDispenseLimitRows(
    prescriptionPad.medicationPadItems,
    prescriptionPad.dispenseLimits,
  );
  setRevalidatedPad(
    set,
    {
      ...prescriptionPad,
      medicationPadItems:
        prescriptionPad.step === step
          ? prescriptionPad.medicationPadItems
          : prescriptionPad.medicationPadItems.map((item) =>
              syncDosageSuffixToStep(item, dispenseLimitRows, prescriptionPadRules, step),
            ),
    },
    prescriptionPadRules,
    'prescriptionPad/updatePrescriptionPadStep',
    (state) => {
      state.prescriptionAssistant.prescriptionPad.step = step;
    },
    dispenseLimitRows,
  );
};
